import React, { useState } from 'react';
import { createUserWithEmailAndPassword } from "firebase/auth"; // 必要な関数をインポート
import { auth } from '../services/firebaseConfig';  // Firebaseの設定をインポート

function SignUp({ onSignUp }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');  // 登録成功メッセージ用の状態

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Firebaseのサインアップ処理
      const userCredential = await createUserWithEmailAndPassword(auth, email, password); // auth、メール、パスワードを渡す
      const user = userCredential.user;
      
      // 登録後、ユーザーIDを親コンポーネントに渡す
      onSignUp(user.uid);  // FirebaseのユーザーIDをonSignUpに渡す

      // 登録成功後のメッセージ
      setSuccessMessage("登録が完了しました！");

      // メッセージを5秒後に消す
      setTimeout(() => {
        setSuccessMessage('');
      }, 5000); // 5秒後にメッセージをリセット
    } catch (err) {
      setError(err.message);  // Firebaseのエラーメッセージを表示
    }
  };

  return (
    <div className="max-w-md mx-auto bg-white p-6 rounded-md shadow-md">
      <h2 className="text-xl font-bold mb-4">新規登録</h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label className="block text-sm font-semibold">メールアドレス</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full p-2 border rounded"
            required
          />
        </div>
        <div className="mb-4">
          <label className="block text-sm font-semibold">パスワード</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full p-2 border rounded"
            required
          />
        </div>
        {error && <p className="text-red-500 text-sm">{error}</p>} {/* エラーメッセージ表示 */}
        {successMessage && <p className="text-green-500 text-sm">{successMessage}</p>} {/* 登録成功メッセージ表示 */}
        <button type="submit" className="w-full bg-blue-500 text-white py-2 rounded">
          登録
        </button>
      </form>
    </div>
  );
}

export default SignUp;
